import LeistungsseiteTemplate from "@/components/feature/LeistungsseiteTemplate";
import BewerbungForm from "@/components/feature/BewerbungForm";
import karriereWasUnsAusmachtAsset from "@/assets/karriere-was-uns-ausmacht.jpg";
import karriereHeaderBgAsset from "@/assets/karriere-header-bg.jpg";
import Seo, { serviceSchema } from "@/components/feature/Seo";
export default function Karriere() {
  return (
    <>
      <Seo
        title="Karriere & Jobs | Zweering Elektrotechnik Emmerich am Rhein"
        description="Karriere bei Zweering Elektrotechnik in Emmerich am Rhein: Elektrohandwerk am Niederrhein mit Perspektive, Wertschätzung und modernem Anspruch."
        canonical="https://zweering.de/karriere"
        breadcrumbs={[{"name": "Startseite", "url": "https://zweering.de/"}, {"name": "Karriere", "url": "https://zweering.de/karriere"}]}
      />
      <LeistungsseiteTemplate
      label="KARRIERE"
      title={
        <>
          Verstärkung gesucht.
          <br />
          Deine Zukunft bei Zweering:
        </>
      }
      subline="Elektrohandwerk am Niederrhein — mit Perspektive, Wertschätzung und modernem Anspruch."
      heroImage={karriereHeaderBgAsset}
      heroImageAlt="Zweering Elektrotechnik Firmengebäude und Fahrzeug mit Logo"
      panels={[
        {
          title: "GESELLE & MEISTER MIT PROJEKT­LEITER­FUNKTION (m/w/d)",
          body: (
            <>
              <p style={{ marginBottom: "1.5rem" }}>
                Wir suchen Verstärkung in der Elektroinstallation. Ob frisch ausgelernt oder mit Projektleitungs-Erfahrung — bei Zweering Elektrotechnik findest du ein starkes Team, faire Bedingungen und echte Wertschätzung.
              </p>
              <h4 style={{ fontWeight: 700, textTransform: "uppercase", fontSize: "0.875rem", letterSpacing: "0.05em", marginBottom: "0.75rem" }}>Deine Aufgaben</h4>
              <ul style={{ listStyle: "disc", paddingLeft: "1.25rem", marginBottom: "1.5rem", display: "grid", gap: "0.5rem" }}>
                <li>Installation und Wartung von Elektroanlagen im Wohn- und Gewerbebau</li>
                <li>Photovoltaik- und Speicherinstallationen</li>
                <li>Kundenbetreuung vor Ort und Beratung zu modernen Energiesystemen</li>
                <li>Projektkoordination und Teamführung (bei Meister-/Projektleiter-Qualifikation)</li>
                <li>Qualitätssicherung und Dokumentation der ausgeführten Arbeiten</li>
              </ul>
            </>
          ),
          image: "https://www.zweering-elektrotechnik.de/wp-content/uploads/2024/11/IMG_0143.jpeg",
          imageAlt: "Elektroinstallation auf Baustelle — Zweering Elektrotechnik",
        },
        {
          title: "DAS ERWARTET DICH",
          body: (
            <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "grid", gap: "0.75rem" }}>
              {[
                "Firmenwagen — auch zur privaten Nutzung",
                "Urlaubsgeld & Weihnachtsgeld",
                "Attraktive Vergütung mit Entwicklungspotenzial",
                "Verantwortung als Projektleitung möglich",
                "Feste Anstellung & abwechslungsreiche Aufgaben",
              ].map((item) => (
                <li key={item} style={{ display: "flex", gap: "0.75rem", alignItems: "flex-start" }}>
                  <span style={{ color: "#4CAF50", fontWeight: 700, lineHeight: 1.4 }}>✓</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          ),
          image: karriereWasUnsAusmachtAsset,
          imageAlt: "Mitarbeiter bei der Elektroinstallation mit Akkuschrauber — Zweering Elektrotechnik",

        },
        {
          title: "DAS BRINGST DU MIT",
          body: (
            <>
              <ul style={{ listStyle: "disc", paddingLeft: "1.25rem", marginBottom: "1.5rem", display: "grid", gap: "0.5rem" }}>
                <li>Abgeschlossene Ausbildung als Elektroniker/Elektroinstallateur (für die Projektleiter-Variante: Meisterqualifikation)</li>
                <li>Führerschein Klasse B</li>
                <li>Teamfähigkeit, Zuverlässigkeit und selbstständige Arbeitsweise</li>
                <li>Interesse an moderner Elektrotechnik und erneuerbaren Energien</li>
                <li>Technisches Verständnis und gute Kommunikation mit Kunden</li>
              </ul>
              <p style={{ marginBottom: "0.5rem" }}>
                <strong>Standort:</strong> Emmerich am Rhein und Umgebung / Niederrhein
              </p>
              <p>
                Ob du als Geselle ins Berufsleben einsteigst oder als Meister Verantwortung übernehmen willst — bei uns findest du moderne Technik, ein familiäres Umfeld und langfristige Perspektiven aus einer Hand.
              </p>
            </>
          ),
          image: "https://www.zweering-elektrotechnik.de/wp-content/uploads/2025/11/IMG_0093.webp",
          imageAlt: "Geschäftsführer im Büro — Zweering Elektrotechnik",
        },
      ]}
      preManifestSection={
        <section className="bg-[#F4F4F4] py-36 md:py-40 px-6 md:px-10 lg:px-14">
          <div className="max-w-7xl mx-auto">
            <h2
              data-split-reveal
              className="font-bold uppercase text-[#0A0A0A] leading-[0.95] break-words mb-16"
              style={{
                fontSize: "clamp(1.375rem, 5vw, 3.5rem)",
                letterSpacing: "clamp(-0.4px, -0.12vw, -1.8px)",
              }}
            >
              DREI WEGE ZU UNS
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
              {[
                {
                  label: "AUSBILDUNG",
                  headline: "Elektroniker:in für Energie- und Gebäudetechnik (m/w/d)",
                  text: "Praxisnahe Ausbildung — von Anfang an Teil des Teams. Moderne Technik, erfahrene Kolleg:innen, Perspektive nach der Lehre.",
                  cta: "Jetzt Ausbildung starten",
                  href: "mailto:info@elektro-zweering.de?subject=Bewerbung%20Ausbildung",
                },
                {
                  label: "PRAKTIKUM",
                  headline: "Schnuppertag oder Schülerpraktikum",
                  text: "Einen Tag reinschnuppern oder mehrere Wochen den Berufsalltag miterleben. Beides möglich — sprich uns einfach an.",
                  cta: "Praktikum anfragen",
                  href: "mailto:info@elektro-zweering.de?subject=Praktikum",
                },
                {
                  label: "INITIATIV",
                  headline: "Auch ohne Stellenausschreibung",
                  text: "Du bringst Technik-Verständnis, Teamgeist und Interesse an moderner Elektrotechnik mit? Dann melde dich — wir suchen immer engagierte Leute.",
                  cta: "Werde Teil des Teams",
                  href: "mailto:info@elektro-zweering.de?subject=Initiativbewerbung",
                },
              ].map((card) => (
                <div
                  key={card.label}
                  className="bg-white rounded-2xl p-8 md:p-10 flex flex-col h-full"
                >
                  <p className="text-[#4CAF50] uppercase text-xs md:text-sm tracking-widest mb-4 font-medium">
                    {card.label}
                  </p>
                  <h3
                    className="font-bold uppercase text-[#0A0A0A] leading-[1.05] mb-5"
                    style={{
                      fontSize: "clamp(1.25rem, 2vw, 1.5rem)",
                      letterSpacing: "-0.5px",
                    }}
                  >
                    {card.headline}
                  </h3>
                  <p className="text-foreground-600 text-base leading-relaxed mb-8 flex-1">
                    {card.text}
                  </p>
                  <a
                    href={card.href}
                    className="btn-slide btn-fill-white inline-flex items-center self-start px-6 py-3.5 rounded-full text-sm font-medium transition-all bg-[#0A0A0A] text-white"
                  >
                    {card.cta} →
                  </a>
                </div>
              ))}
            </div>
          </div>
        </section>
      }
      manifest={<span className="normal-case">Mensch.<br />Handwerk.<br />Zukunft.</span>}
      ctaText={{
        headline: "INTERESSE GEWECKT?",
        subtext: "Schick uns deine Bewerbung — kurzer Weg, schnelle Rückmeldung.",
        buttonLabel: "Jetzt bewerben",
        buttonHref: "#bewerbung",
        variant: "green",
      }}
      postCtaSection={
        <div id="bewerbung">
          <BewerbungForm />
        </div>
      }
      crossLink={{
        title: "ÜBER UNS",
        text: "Lerne den Betrieb hinter dem Handwerk kennen.",
        href: "/ueber-uns",
        image: "https://www.zweering-elektrotechnik.de/wp-content/uploads/2025/11/IMG_0099.webp",
        imageAlt: "Firmenanhänger Zweering Elektrotechnik",
      }}
    />
    </>
  );
}
